import { call, put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, convertIsoDateToString, showSuccess } from 'utils';
import customerApi from 'api/customerApi';

import CustomerActions from './actions';
import CustomerActionTypes from './actionTypes';

const mapApiCustomerToFrontend = (apiCustomer) => {
  const birthdayStr = convertIsoDateToString(apiCustomer.birthday) || '—';

  return {
    ...apiCustomer,
    birthday: birthdayStr,
  };
};

function* getCustomers({ payload }) {
  try {
    const response = yield call(customerApi.getCustomerList, payload);
    const rawData = response.payload?.data || response.payload || [];
    const total = response.payload?.total || response.total || 0;

    const data = rawData.map(mapApiCustomerToFrontend);

    yield put(CustomerActions.getCustomersSuccess({ data, total }));
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.getCustomersFailed());
  }
}

function* getCustomerDetails({ payload: id }) {
  try {
    const response = yield call(customerApi.getCustomerDetails, id);
    const data = mapApiCustomerToFrontend(response.payload || response);

    yield put(CustomerActions.getCustomerDetailsSuccess(data));
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.getCustomerDetailsFailed());
  }
}

function* getCustomerBookings({ payload }) {
  try {
    const response = yield call(customerApi.getCustomerBookings, payload);
    const bookings = response.payload?.data || [];
    const total = response.payload?.total || 0;

    yield put(
      CustomerActions.getCustomerBookingsSuccess({
        data: bookings,
        total,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.getCustomerBookingsFailed());
  }
}

function* exportCustomerFile({ payload }) {
  try {
    const response = yield call(customerApi.exportCustomerFile, payload);

    window.open(response.payload.downloadUrl, '_blank');

    yield put(CustomerActions.exportCustomerFileSuccess());
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.exportCustomerFileFailed());
  }
}

function* blockCustomer({ payload }) {
  try {
    const id = typeof payload === 'string' ? payload : payload.id;
    const callback = typeof payload === 'object' ? payload.callback : undefined;

    yield call(customerApi.blockCustomer, id);

    showSuccess('Chặn khách hàng thành công');

    yield put(CustomerActions.blockCustomerSuccess());

    if (callback) {
      yield call(callback);
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.blockCustomerFailed());
  }
}

function* unblockCustomer({ payload }) {
  try {
    const id = typeof payload === 'string' ? payload : payload.id;
    const callback = typeof payload === 'object' ? payload.callback : undefined;

    yield call(customerApi.unblockCustomer, id);

    showSuccess('Bỏ chặn khách hàng thành công');

    yield put(CustomerActions.unblockCustomerSuccess());

    if (callback) {
      yield call(callback);
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.unblockCustomerFailed());
  }
}

function* updateCustomerLevel({ payload }) {
  try {
    const { id, level, callback } = payload;

    yield call(customerApi.updateCustomerLevel, id, { level });

    showSuccess('Nâng cấp tài khoản thành công');

    yield put(CustomerActions.updateCustomerLevelSuccess());

    if (callback) {
      yield call(callback);
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put(CustomerActions.updateCustomerLevelFailed());
  }
}

export default function* customer() {
  yield takeLeading(CustomerActionTypes.GET_CUSTOMERS, getCustomers);
  yield takeLeading(CustomerActionTypes.GET_CUSTOMER_DETAILS, getCustomerDetails);
  yield takeLeading(CustomerActionTypes.GET_CUSTOMER_BOOKINGS, getCustomerBookings);
  yield takeLeading(CustomerActionTypes.EXPORT_CUSTOMER_FILE, exportCustomerFile);
  yield takeLeading(CustomerActionTypes.BLOCK_CUSTOMER, blockCustomer);
  yield takeLeading(CustomerActionTypes.UNBLOCK_CUSTOMER, unblockCustomer);
  yield takeLeading(CustomerActionTypes.UPDATE_CUSTOMER_LEVEL, updateCustomerLevel);
}
